/* 
Menu Types: "menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = "menu-default";
export const subHiddenBreakpoint = 1000;
export const menuHiddenBreakpoint = 768;
/*
export const defaultLocale = "es";
export const localeOptions = [
  { id: "es", name: "Español", direction: "ltr" },
  { id: "en", name: "English", direction: "ltr" }
];
*/
export const title = window.tenant.title;
export const name = window.tenant.name;
export const logo = window.tenant.logo;
export const hero = window.tenant.hero;
export const url = window.tenant.url;
export const lang = localStorage.getItem('__current_locale') || window.tenant.defaultLocale;
export const searchPath = ""; // "/app/pages/search"
export const servicePathDefault = url + 'api';
export const servicePath = localStorage.getItem('servicePath') || servicePathDefault;
export const authType = 1;
export const authParams = {
  Path: servicePathDefault + '/admStaff/login',
  ClientId: "",
  Basic: "cm8uYWRtaW46c2VjcmV0",
  Header: "token",
  GetUser: ""
};
export const topNavOptions = {
  easyAccess: false,
  notifications: false
};
export const tenants = {
  pathAll: "admStaff/tenants",
  pathOne: "getTenant",
  map: o => {
    return {
      "id": o.Id,
      "name": o.Name
    }
  },
  default: [
  ]
};
/* 
Color Options:
"light.purple", "light.blue", "light.green", "light.orange", "light.red", "dark.purple", "dark.blue", "dark.green", "dark.orange", "dark.red"
*/
export const isMultiColorActive = false;
export const defaultColor = window.tenant.theme;
export const defaultDirection = "ltr";
export const isDarkSwitchActive = true;
export const themeColorStorageKey = "__theme_color";

// set title and favicon
(function() {
  if (window.location.host.indexOf('localhost') === -1) document.title = title;
  var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
  link.type = 'image/x-icon';
  link.rel = 'shortcut icon';
  link.href = logo;
  document.getElementsByTagName('head')[0].appendChild(link);
  document.documentElement.lang = lang;
  const themeColorMeta = document.querySelector('meta[name="theme-color"]');
  themeColorMeta.setAttribute('content', window.tenant.mobileStatusBarColor);
})();